import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { IAuthenticationState } from './authentication.state';
export const authenticationAdapter: EntityAdapter<never> =
  createEntityAdapter<never>();

export const authenticationStoreInitialState: IAuthenticationState =
  authenticationAdapter.getInitialState({
    status: 'granted',
  });
